export enum MaritalStatusEnum {
    SINGLE = 1,
    MARRIED = 2,
    DIVORCED = 3,
    WIDOWED = 4,
    DOMESTIC_PARTNERSHIP = 5
}
